<template>
  <div class="page-index" ref="pageIndex">
    <div class="CoalModel_box_title back-content">
      <el-page-header @back="getReturn" content="停车场详情"> </el-page-header>
    </div>
    <el-popover
      popper-class="popoverStyle"
      placement="left-start"
      title="操作"
      width="200"
      trigger="hover">
        <el-button type="primary" :size="size" @click="handleShowOutEnterInfo">实时出入场信息</el-button>
        <!-- <el-button type="primary" :size="size" style="margin: 10px 0;" @click="handleShowManageDialog('enter')">入场手动管理</el-button>
        <el-button type="primary" :size="size" @click="handleShowManageDialog('out')">出场手动管理</el-button> -->
        <el-button type="primary" class="operation" :circle="true" slot="reference">操作</el-button>
    </el-popover>
    <!-- <div class="">操作</div> -->
    <div class="page-header">
      <span class="color-item">
        <span class="color-box" style="background: #ccc"></span>
        <span class="coalType">已禁用</span>
      </span>
      <span class="color-item" v-for="(item, index) in colorRemarkList" :key="index">
        <span class="color-box" :style="`background: ${item.color};`"></span>
        <span class="coalType">{{item.coalCategoryName}}</span>
      </span>
    </div>
    <el-container class="park-carList">
      <el-aside class="aside" width="60px">
        <div class="txt">入口</div>
      </el-aside>
      <el-main>
        <div class="table">
          <div class="row-item header">
            <div 
              v-for="(item, index) in tableColumns"
              :key="index"
              :class="index === 0 ? 'cell-item label': 'cell-item flex'" >
                {{item}}
            </div>
            <!-- <div class="cell-item handle">
              操作
            </div> -->
          </div>
          <div v-for="(item, index) in gridList" :key="index" :class="item.laneStatus == 0 ? 'row-item flex' : 'row-item flex disabled'">
            <div class="cell-item label">
              {{item.laneNo}}
            </div>
            <div
              v-for="(cellItem, cellIndex) in item.carList"
              :key="cellIndex"
              :data-carno="cellItem.carLicensePlateNo"
              :class="cellItem.parkingStatus == 0 ? 'cell-item flex' : 'cell-item flex parkError'"
              :style="`background: ${item.color};`"
              @click="handleShowWaybillInfo">
                {{cellItem.carLicensePlateNo}}{{cellItem.pullBlackStatus == 0 ? '' : '（已拉黑）'}}
                 <!-- <el-button 
                  class="outPark" 
                  v-if="cellIndex == tableColumns.length - 2 && cellItem.carLicensePlateNo && carOutParkFlag != 1"
                  type="text"
                  :size="size"
                  @click.stop="handleOutPark(item.laneNo)">
                    离场
                </el-button> -->
            </div>
            <!-- <div class="cell-item handle" v-if="item.carList.length > 0">
              <el-button :size="size" type="text" @click="handleOperation(item.laneStatus, item.laneNo)">
                {{item.laneStatus == 0 ? '停用' : '启动'}}
              </el-button>
            </div> -->
          </div>
        </div>
        <!-- <el-table
          :data="carList"
          border
          :size="size"
          style="width: 100%"
          :cell-style="cellStyle"
          @cell-click="handleClickCell"
        >
          <el-table-column align="left" width="80px">
            <template slot-scope="scope">
              {{ `${scope.row.laneNo}(${scope.row.coalCategoryName})` }}
            </template>
          </el-table-column>
          <el-table-column
            v-for="(item, index) in tableColumns"
            :key="index"
            align="center"
            :label="item"
          >
            <template slot-scope="scope">
              <span class="carNumber error">{{ scope.row[item] }}</span>
            </template>
          </el-table-column>
        </el-table> -->
      </el-main>
      <el-aside class="aside" width="60px">
        <div class="txt">出口</div>
      </el-aside>
    </el-container>
    <el-dialog
      title="车辆信息"
      :visible.sync="waybillInfoDialogVisible"
      width="30%"
    >
      <div class="carInfoList">
        <div class="item">
          <span class="label">运单编号</span>
          <span class="desc">{{waybillInfo.waybillNo}}</span>
        </div>
        <div class="item">
          <span class="label">托运方</span>
          <span class="desc">{{waybillInfo.purchaseName}}</span>
        </div>
        <div class="item">
          <span class="label">托运煤型</span>
          <span class="desc">{{waybillInfo.coalCategoryName}}</span>
        </div>
        <div class="item">
          <span class="label">卸货地</span>
          <span class="desc">{{waybillInfo.unloadingAddress}}</span>
        </div>
        <div class="item">
          <span class="label">司机</span>
          <span class="desc">{{waybillInfo.driverName}}</span>
        </div>
        <div class="item">
          <span class="label">车牌号</span>
          <span class="desc">{{waybillInfo.carLicensePlateNo}}</span>
        </div>
        <div class="item">
          <span class="label">电话</span>
          <span class="desc">{{waybillInfo.driverPhone}}</span>
        </div>
        <div class="item">
          <span class="label">状态</span>
          <span class="desc">{{waybillInfo.statusDesc}}{{waybillInfo.pullBlackStatus == 0 ? '' : '&已拉黑'}}</span>
        </div>
        <div class="item">
          <span class="label">停放</span>
          <span class="desc">
            {{waybillInfo.parkingPosition}}
          </span>
          <span v-if="waybillInfo.parkingPosition">
            {{waybillInfo.parkingStatus == 0 ? '准确' : '错误'}}
          </span>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      :title="manageTitle"
      :visible.sync="showMangeDialogVisible"
      width="600px"
    >
      <el-form
        :model="manageForm"
        status-icon
        :rules="manageFormRules"
        ref="manageForm"
        label-width="100px"
        class="demo-manageForm"
        :size="size"
      >
        <el-form-item label="运单编号：" prop="waybillNo">
          <el-row :gutter="10">
            <el-col :span="18">
              <el-input type="text" v-model="manageForm.waybillNo"></el-input>
            </el-col>
            <el-col :span="4">
              <kt-button label="查询" perms="-1" type="primary" @click="handleQueryWaybillInfoByWaybillNo"/>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item label="预停车道：" prop="laneNo" v-if="isShowEnterDialog">
          <el-row :gutter="10">
            <el-col :span="18">
              <el-input type="text" v-model="manageForm.laneNo"></el-input>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item label="闸机选择：" prop="gateNumber">
          <el-row :gutter="10">
            <el-col :span="18">
              <el-radio-group v-model="manageForm.gateNumber">
                <el-radio label="1">1号闸机</el-radio>
                <el-radio label="2">2号闸机</el-radio>
              </el-radio-group>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item label="备注：" prop="remark">
          <el-row :gutter="10">
            <el-col :span="18">
              <el-input type="textarea" v-model="manageForm.remark"></el-input>
            </el-col>
          </el-row>
        </el-form-item>
        <div class="waybillInfo" v-if="showWaybillInfo">
          <div class="title">
            运单信息：
          </div>
          <div class="item">
            <span class="label">预约时间：</span>
            <span class="desc">{{manageWaybillInfo.bookingDate}} {{manageWaybillInfo.bookingStartTime + '-' + manageWaybillInfo.bookingEndTime}}</span>
          </div>
          <div class="item" v-if="isShowEnterDialog">
            <span class="label">预停车道：</span>
            <span class="desc">{{manageWaybillInfo.shouldLaneNo}}</span>
          </div>
          <div class="item">
            <span class="label">运单编号：</span>
            <span class="desc">{{manageWaybillInfo.waybillNo}}</span>
          </div>
          <div class="item">
            <span class="label">托运方：</span>
            <span class="desc">{{manageWaybillInfo.purchaseName}}</span>
          </div>
          <div class="item">
            <span class="label">托运煤型：</span>
            <span class="desc">{{manageWaybillInfo.coalCategoryName}}</span>
          </div>
          <div class="item">
            <span class="label">卸货地：</span>
            <span class="desc">{{manageWaybillInfo.unloadingAddress}}</span>
          </div>
          <div class="item">
            <span class="label">司机：</span>
            <span class="desc">{{manageWaybillInfo.driverName}}</span>
          </div>
          <div class="item">
            <span class="label">车牌号：</span>
            <span class="desc">{{manageWaybillInfo.carLicensePlateNo}}</span>
          </div>
          <div class="item">
            <span class="label">电话：</span>
            <span class="desc">{{manageWaybillInfo.driverPhone}}</span>
          </div>
          <div class="item">
            <span class="label">状态：</span>
            <span class="desc">{{manageWaybillInfo.statusDesc}}</span>
          </div>
          <div class="item" v-if="!isShowEnterDialog">
            <span class="label">停放：</span>
            <span class="desc">
              {{waybillInfo.parkingPosition}}
            </span>
            <span v-if="waybillInfo.parkingPosition">
              {{waybillInfo.parkingStatus == 0 ? '准确' : '错误'}}
            </span>
          </div>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer" v-if="isShowEnterDialog">
        <el-button :size="size" type="primary" @click="handleAllowEnter">允许入场</el-button>
        <!-- <el-button :size="size" type="danger" @click="handleAddBlackList">加入黑名单</el-button> -->
      </div>
      <div slot="footer" class="dialog-footer" v-else>
        <el-button :size="size" type="primary" @click="handleAllowOut">允许出场</el-button>
        <el-button :size="size" type="danger" @click="handleAddBlackList">加入黑名单</el-button>
      </div>
    </el-dialog>
    <div class="notice-dialog" v-if="showNotice">
      <div class="handleClose" @click="handleCloseNotice">
        <i class="el-icon-close"></i>
      </div>
      <div class="notify-title">入场信息</div>
      <div class="info-list">
        <div class="item">
          <span class="label">识别车辆：</span>
          <span class="desc">{{enterParkInfo.carLicensePlateNo}}</span>
        </div>
        <div class="item">
          <span class="label">所属公司：</span>
          <span class="desc">{{enterParkInfo.purchaseName}}</span>
        </div>
        <div class="item">
          <span class="label">待装煤型：</span>
          <span class="desc">{{enterParkInfo.coalCategoryName}}</span>
        </div>
        <div class="item">
          <span class="label">待入车道：</span>
          <span class="desc">{{enterParkInfo.laneNo}}</span>
        </div>
      </div>
      <div class="notify-title">出场信息</div>
      <div class="info-list">
        <div class="item">
          <span class="label">识别车辆：</span>
          <span class="desc">{{outParkInfo.carLicensePlateNo}}</span>
        </div>
        <div class="item">
          <span class="label">所属公司：</span>
          <span class="desc">{{outParkInfo.purchaseName}}</span>
        </div>
        <div class="item">
          <span class="label">待装煤型：</span>
          <span class="desc">{{outParkInfo.coalCategoryName}}</span>
        </div>
        <div class="item">
          <span class="label">应出车道：</span>
          <span class="desc">{{outParkInfo.laneNo}}</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import SockJS from  'sockjs-client';
import  Stomp from 'stompjs';
import KtButton from "@/components/Core/KtButton";
import global from '@/utils/global'

export default {
  components: {
    KtButton,
  },
  props: {
    parkDetailParams: {
      type: Object,
      required: true
    },
  },
  data() {
    return {
      size: "small",
      carOutParkFlag: 1,
      tableColumns: [],
      gridList: [],
      colorRemarkList: [],
      waybillInfoDialogVisible: false,
      waybillInfo: {},
      showNotice: false,
      enterParkInfo: {
        carLicensePlateNo: '',
        coalCategoryName: '',
        purchaseName: '',
        laneNo: ''
      },
      outParkInfo: {
        carLicensePlateNo: '',
        coalCategoryName: '',
        purchaseName: '',
        laneNo: ''
      },
      stompClient:'',
      timer:'',
      manageTitle: '入场手动管理',
      isShowEnterDialog: true,
      showMangeDialogVisible: false,
      manageForm: {
        waybillNo: '',
        laneNo: '',
        gateNumber: '1',
        remark: ''
      },
      manageFormRules: {
        waybillNo: [{ required: true, message: '请输入运单编号', trigger: 'blur' }],
        laneNo: [{ required: true, message: '请输入预停车道', trigger: 'blur' }],
        gateNumber: [{ required: true, message: '请选择闸机', trigger: 'change' }],
        remark: [{ required: true, message: '请输入备注', trigger: 'change' }]
      },
      showWaybillInfo: false,
      manageWaybillInfo: {},
    };
  },
  mounted() {
    // this.getParkSetting()
    this.getOutParkCarInfo()
    this.getParkGridList()
    this.getEnterParkCarInfo()
    this.getNoticeType()
    this.timer = setInterval(() => {
      this.getNoticeType()
    }, 2000)
    // this.initWebSocket()
  },
  beforeDestroy() {
    // 页面离开时断开连接,清除定时器
    // this.disconnect();
    this.timer && clearInterval(this.timer);
  },
  destroyed () {
    this.timer && clearInterval(this.timer);
  },
  methods: {
    getReturn() {
      this.$emit("backFun", false);
    },
    //轮询请求通知类型
    async getNoticeType(type){
      let res = await this.$api.park.mGetNoticeType()
      
      if(!res.data.noticeType) return
      let noticeType = res.data.noticeType
      switch(noticeType){
        case 'enterPark':
          this.getEnterParkCarInfo()
        break;
        case 'outPark':
          this.getOutParkCarInfo();
        break;
        case 'grid':
          this.getParkGridList()
        break;
      } 
    },
    // 获取停车场设置
    // async getParkSetting(){
    //   let res = await this.$api.setting.mGetParkSetting()
    //   console.log(res)
    //   this.carOutParkFlag = res.data.carOutParkFlag
    // },
    // 初始化websocket
    // initWebSocket(){
    //   this.connection();
    //   let _t = this;
    //   // 断开重连机制,尝试发送消息,捕获异常发生时重连
    //   this.timer = setInterval(() => {
    //     try {
    //       _t.stompClient.send('测试连接是否正常');
    //     } catch (err) {
    //       this.$message.error(`websocket断线了：${err}`);
    //       _t.connection();
    //     }
    //   }, 5000);
    // },

    // //连接 后台
    // connection() {
    //   const loading = this.$loading({
    //     lock: true,
    //     text: '连接中...',
    //     spinner: 'el-icon-loading',
    //     background: 'rgba(0, 0, 0, 0.7)'
    //   })
    //   // 建立连接对象
    //   let socket = new SockJS('http://119.3.171.9:8843/simple');
    //   // let socket = new SockJS(`${global.baseUrl}/simple`);
    //   // 获取STOMP子协议的客户端对象
    //   this.stompClient = Stomp.over(socket);
    //   // 定义客户端的认证信息,按需求配置
    //   let headers = {
    //     Authorization:''
    //   }
    //   // 向服务器发起websocket连接
    //   this.stompClient.connect(headers,() => {
    //     loading.close()
    //     this.stompClient.subscribe('/topic/callback', (msg) => { // 订阅服务端提供的某个topic
    //       console.log(`接受信息成功${msg.body}`)
    //       this.socketCallback(msg.body)
    //     }, headers);
    //   }, (err) => {
    //     // 连接发生错误时的处理函数
    //     this.$message({
    //       message: 'websocket链接失败, ' + err,
    //       type: 'error'
    //     })
    //   });
    // },

    // // 断开连接
    // disconnect() {
    //   if (this.stompClient) {
    //     this.stompClient.disconnect();
    //   }
    // },

    // // 根据通知类型掉不同的方法
    // socketCallback(type){
    //   switch(type){
    //     case 'enterPark':
    //       this.getEnterParkCarInfo()
    //     break;
    //     case 'outPark':
    //       this.getOutParkCarInfo();
    //     break;
    //     case 'grid':
    //       this.getParkGridList()
    //     break;
    //   } 
    // },

    // 获取表格
    async getParkGridList(){
      this.colorRemarkList = [];
      let res = await this.$api.park.mGetParkGridList({
        coalMineNo: this.parkDetailParams.coalMineNo,
        parkNo: this.parkDetailParams.parkNo
      })
      res.data.headerList = !res.data.headerList ? [] : res.data.headerList
      res.data.gridList = !res.data.gridList ? [] : res.data.gridList
      let colorList = ['#F8D978', '#B0CE94', '#99CCCC', '#FFFFCC', '#CCCCFF', '#99CCFF', '#999933', '#FFCC99', '#FFEBCD', '#FFDEAD', '#F0FFFF', '#BBFFFF', '#90EE90', '#BDB76B', '#F5F5DC']
      let headerList = JSON.parse(JSON.stringify(res.data.headerList))
      headerList.length > 1 && headerList.shift()
      res.data.gridList.length > 0 && res.data.gridList.map((item, index) => {
        let coalCategoryName = item.coalCategoryName
        let colorRemarkList = JSON.parse(JSON.stringify(this.colorRemarkList))

        if(coalCategoryName){
          let hasColorItem = colorRemarkList.find(i => {
            return i.coalCategoryName == coalCategoryName
          })
          if(colorRemarkList.length < 0 || !hasColorItem){
            item.color = colorList[0]
            colorList.shift()
            colorRemarkList.push({
              color: item.color,
              coalCategoryName: coalCategoryName
            })
          } else {
            item.color = hasColorItem.color
          }
        } else {
          item.color = ''
        }
        
        if(item.carList.length < 1){
          let target = []
          headerList.forEach(i => {
            target.push('')
          })
          item.carList = target
        }

        this.colorRemarkList = colorRemarkList
      })

      // console.log(this.colorRemarkList)
      this.gridList = res.data.gridList
      this.tableColumns = res.data.headerList;
    },

    // 获取入场车辆信息
    async getEnterParkCarInfo(){
      let res = await this.$api.park.mGetEnterParkCarInfo()
      if(+res.data.laneNo === 0) return
      this.enterParkInfo = res.data
    },

    // 获取出厂车辆信息
    async getOutParkCarInfo(){
      let res = await this.$api.park.mGetOutParkCarInfo()
      if(+res.data.laneNo === 0) return
      this.outParkInfo = res.data
    },

    // 展示出入场信息弹窗
    handleShowOutEnterInfo(){
      this.showNotice = true
    },

    // 关闭notice
    handleCloseNotice(){
      this.showNotice = false
    },

    // 根据车牌号获取运单信息
    async handleShowWaybillInfo(e){
      let carNo = e.currentTarget.dataset.carno;
      if(!carNo) return
      let res = await this.$api.park.mGetWaybillInfoByCarLicensePlateNo({
        carLicensePlateNo: carNo
      })
      this.waybillInfo = res.data
      this.waybillInfoDialogVisible = true
    },

    // 手动管理
    handleShowManageDialog(type) {
      if(type === 'enter'){
        this.isShowEnterDialog = true
        this.manageTitle = '入场手动管理'
      } else {
        this.isShowEnterDialog = false
        this.manageTitle = '出场手动管理'
      }
      this.showMangeDialogVisible = true
      this.manageForm = {
        waybillNo: '',
        laneNo: '',
        gateNumber: '1',
        remark: ''
      }
      this.showWaybillInfo = false;
      this.manageWaybillInfo = {}
    },

    // 根据运单号查询运单信息
    async handleQueryWaybillInfoByWaybillNo(){
      if(!this.manageForm.waybillNo){
        this.$message({
          message: '请输入运单号',
          type: 'error'
        })
        return;
      }

      let res = await this.$api.park.mGetWaybillInfoByWaybillNo({
        waybillNo: this.manageForm.waybillNo
      })

      if(!res.data.waybillNo){
        this.$message({
          message: '请输入正确的运单号',
          type: 'error'
        })
        return;
      }

      this.showWaybillInfo = true
      this.manageWaybillInfo = res.data
      this.manageForm.laneNo = res.data.shouldLaneNo
    },

    // 允许入场
    handleAllowEnter(){
      this.$refs['manageForm'].validate(async (valid) => {
        if (valid) {
          if(JSON.stringify(this.manageWaybillInfo) == "{}"){
            this.$message({
              message: '请查询运单信息',
              type: 'warning'
            })
            return;
          }
          let res = await this.$api.park.mAllowEnterPark({
            ...this.manageForm
          })

          this.$message({
            message: '操作成功',
            type: 'success'
          })
          setTimeout(() =>{
            this.$refs['manageForm'].resetFields()
            this.showMangeDialogVisible = false
            this.manageWaybillInfo = {}
            this.getParkGridList()
          }, 500)
        }
      })
    },

    // 允许出场
    handleAllowOut(){
      this.$refs['manageForm'].validate(async (valid) => {
        if (valid) {
          if(JSON.stringify(this.manageWaybillInfo) == "{}"){
            this.$message({
              message: '请先查询运单信息',
              type: 'warning'
            })
            return;
          }
          let res = await this.$api.park.mAllowOutPark({
            waybillNo: this.manageForm.waybillNo,
            gateNumber: this.manageForm.gateNumber,
            remark: this.manageForm.remark
          })

          this.$message({
            message: '操作成功',
            type: 'success'
          })
          setTimeout(() =>{
            this.$refs['manageForm'].resetFields()
            this.showMangeDialogVisible = false
            this.manageWaybillInfo = {}
            this.getParkGridList()
          }, 500)
        }
      })
    },

    // 加入黑名单
    handleAddBlackList(){
      this.$refs['manageForm'].validate(async (valid) => {
        if (valid) {
          if(JSON.stringify(this.manageWaybillInfo) == "{}"){
            this.$message({
              message: '请查询运单信息',
              type: 'warning'
            })
            return;
          }

          let confirm = await this.$confirm('是否确认拉黑该车辆，拉黑后该车辆不可继续报名该煤矿运输', '拉黑车辆').catch(() => {
            console.log('取消操作')
          })
          if(!confirm) return

          let res = await this.$api.park.mPullBlack({
            carLicensePlateNo: this.manageWaybillInfo.carLicensePlateNo
          })

          this.$refs['manageForm'].resetFields()
          this.showMangeDialogVisible = false
          this.manageWaybillInfo = {}
          this.getParkGridList()
        }
      })
    },

    // 配置手动离场
    async handleOutPark(lineno){
      let confirm = await this.$confirm('确认是否离场？').catch(() => {
        console.log('取消操作')
      })

      if(!confirm) return
      console.log('111')
      let res = await this.$api.park.handleOutPark({
        laneNo: lineno
      })
      
      this.$message({
        message: '离场成功',
        type: 'success'
      })

      this.getParkGridList()
    },

    // 停用启用
    async handleOperation(status, laneNo){
      console.log(status, laneNo)
      let confirm = await this.$confirm(+status === 0 ? '是否停用当前车道？' : '是否启用当前车道？').catch(() => {
        console.log('取消操作')
      })

      if(!confirm) return
      let res = +status === 0 ? await this.$api.park.mDisableLane({
        laneNo
      }) : await this.$api.park.mEnableLane({
        laneNo
      }) 
      console.log(res)
      
      this.$message({
        message: +status === 0 ? '停用成功' : '启动成功',
        type: 'success'
      })

      this.getParkGridList()
    }
  },
  computed: {},
};
</script>
<style lang="scss" scoped>
$borderColor: #000000;
.page-index {
  width: 100%;
  height: 100%;
  background: #fff;
  box-sizing: border-box;
  padding-top: 90px;
}
.back-content{
  padding: 15px 0;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background: #fff;
  border-bottom: 1px solid #DCDFE6;
}
.park-carList{
  width: 100%;
  height: 100%;
}


.operation{
  position: fixed;
  right: 20px;
  bottom: 20px;
  z-index: 2000;
  // border-radius: 50%;
  height: 55px;
  width: 55px;
  margin: 0;
  // background: radial-gradient(circle at 35px 35px, rgb(4, 87, 253, 0.9), rgb(1, 87, 173, 0.9));
  // background: rgba($color: blue, $alpha: 0.9);
  font-size: 14px;
  color: #fff;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
}

.page-header{
  position: absolute;
  top: 65px;
  left: 0;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  .color-item{
    padding: 0 5px;
    .color-box{
      display: inline-block;
      width: 12px;
      height: 12px;
      background: red;
    }
    .coalType{
      font-size: 14px;
      padding-left: 5px;
    }
  }
}
.table{
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  border: 1px solid $borderColor;
  display: flex;
  flex-direction: column;
  font-size: 12px;
  overflow-y: scroll;
  .flex{
    flex: 1;
    width: 100%;
  }
  .row-item{
    display: flex;
    box-sizing: border-box;
    border-bottom: 1px solid $borderColor;
    &:last-child{
      border: none;
    }
    &.disabled{
      background: #ccc;
    }
    &.header{
      height: 32px;
      background: #93A8D6;
    }
    .cell-item{
      padding: 2px 0;
      box-sizing: border-box;
      border-right: 1px solid $borderColor;
      display: flex;
      justify-content: center;
      align-items: center;
      &:last-child{
        border: none;
      }
      &.parkError{
        color: red;
      }
      &.label{
        width: 50px;
        background: #93A8D6;
      }
      &.handle{
        width: 80px;
      }
      .outPark{
        margin-left: 5px;
        height: 30px;
      }
    }
  }
}


.el-container {
  border-left: 1px solid $borderColor;
  border-right: 1px solid $borderColor;
  .aside {
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: 600;
    letter-spacing: 10px;
    border-top: 1px solid $borderColor;
    border-bottom: 1px solid $borderColor;
    background: #fff;
    .txt {
      width: 80px;
      height: 30px;
      display: inline-block;
      transform: rotate(90deg);
      text-align: center;
    }
  }
  .el-main {
    padding: 0;
    .carNumber.error {
      color: red;
    }
  }
}
.carInfoList {
  .item {
    padding: 5px 0;
    .label {
      display: inline-block;
      width: 100px;
    }
  }
}
.waybillInfo {
  color: #606266;
  .title{
    width: 88px;
    box-sizing: border-box;
    text-align: right;
    padding: 8px 0;
    font-weight: bold;
  }
  .item {
    padding: 5px 0;
    .label {
      display: inline-block;
      width: 120px;
      box-sizing: border-box;
      padding-right: 12px;
      text-align: right;
    }
  }
}
.notice-dialog{
  position: fixed;
  left: 220px;
  bottom: 20px;
  z-index: 9999;
  background: #fff;
  padding: 20px 80px 20px 50px;
  box-shadow: 0 0 15px #ccc;
  border-radius: 10px;
  .handleClose{
    position: absolute;
    right: 0;
    top: 0;
    width: 40px;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .notify-title{
    font-size: 16px;
    font-weight: bold;
    color: #000;
    margin: 10px 0;
  }
  .info-list{
    font-size: 14px;
    .item{
      margin-top: 3px;
      &:first-child{
        margin-top: 0;
      }
      .label{
        padding-right: 10px;
      }
    }
  }

}

</style>
<style lang="scss">
$borderColor: #000000;
.page-index {
  .red {
    background: #fff;
  }
}
.custom-notification {
  width: 400px;
  left: 210px !important;
  .info-list{
    .item {
      width: 300px;
      padding: 1px 0;
      color: #333;
    }
  }
}
.popoverStyle{
  text-align: center;
}
.popoverStyle .el-button+.el-button{
  margin-left: 0;
}

</style>
